import { Injectable } from "@angular/core";
import { ProdutosProvider } from "../../providers/products/products";
import { Product, ProductsModel } from "./produtos.modelview";
import { Observable } from "rxjs/Observable";

@Injectable()
export class ProdutosPageProvider {
    constructor(public productsProvider: ProdutosProvider) {

    }

    requestProducts(): Observable<ProductsModel> {
        return Observable.create(observer => {
            this.productsProvider.requestProducts().subscribe(data => {

                let model: ProductsModel = new ProductsModel()

                var estudos: Array<Product> = []
                var tipos: Array<string> = []
                tipos.push("")

                var canAdd = true

                data.forEach(element => {
                    canAdd = element.acf.produto_visivel;
                    if (canAdd)
                    {
                        var estudo: Product = new Product()
                        estudo.name = element.title.rendered
                        estudo.description = element.content.rendered

                        if (element.acf != undefined 
                            && element.acf.imagens != undefined) {
                            estudo.bula_ampliada = element.acf.bula_ampliada && element.acf.bula_ampliada != "" ? element.acf.bula_ampliada.replace("http:///", "") : undefined
                            estudo.bula_paciente = element.acf.bula_paciente && element.acf.bula_paciente != "" ? element.acf.bula_paciente.replace("http:///", "") : undefined
                            estudo.bula_profissional = element.acf.bula_profissional && element.acf.bula_profissional != "" ? element.acf.bula_profissional.replace("http:///", "") : undefined
                            estudo.bula_audio = element.acf.bula_audio && element.acf.bula_audio != "" ? element.acf.bula_audio : undefined
                            estudo.tipo_produto = element.acf.tipo_produto && element.acf.tipo_produto != "" ? element.acf.tipo_produto : undefined
                            estudo.subtitulo_produto = element.acf.subtitulo_produto && element.acf.subtitulo_produto != "" ? element.acf.subtitulo_produto : undefined

                            window.location.host
                            estudo.images = []

                            if (element.acf.imagens != undefined || element.acf.imagens != "") {
                                element.acf.imagens.map(it => {
                                    estudo.images.push(it.url)
                                })
                            }

                            


                            if (element.acf.tipo_produto != undefined) {
                                var nTipo = element.acf.tipo_produto

                                if (tipos.indexOf(nTipo) == -1)
                                    tipos.push(nTipo)
                            }
                        }

                    
                        estudos.push(estudo);
                    }
                });

                model.products = estudos
                model.tipos = tipos

                observer.next(model)
            }, err => {
                observer.error(err)
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/produtos/produtos.provider.ts